/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CompanyLayoutStatusType = "ACTIVE" | "DRAFT" | "%future added value";
export type UpdateCompanyLayoutMutationVariables = {|
  companyId: string,
  companyLayoutId: number,
  name: string,
  layout: string,
  status?: ?CompanyLayoutStatusType,
|};
export type UpdateCompanyLayoutMutationResponse = {|
  +Me: ?{|
    +Company: ?{|
      +businessPost: ?{|
        +updateCompanyLayout: ?{|
          +id: string,
          +tableId: number,
          +name: string,
          +status: CompanyLayoutStatusType,
        |}
      |}
    |}
  |}
|};
export type UpdateCompanyLayoutMutation = {|
  variables: UpdateCompanyLayoutMutationVariables,
  response: UpdateCompanyLayoutMutationResponse,
|};
*/


/*
mutation UpdateCompanyLayoutMutation(
  $companyId: ID!
  $companyLayoutId: Int!
  $name: String!
  $layout: String!
  $status: CompanyLayoutStatusType
) {
  Me {
    Company(id: $companyId) {
      businessPost {
        updateCompanyLayout(companyLayoutId: $companyLayoutId, name: $name, layout: $layout, status: $status) {
          id
          tableId
          name
          status
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyLayoutId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "layout"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutations",
    "kind": "LinkedField",
    "name": "Me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "companyId"
          }
        ],
        "concreteType": "CompanyMutations",
        "kind": "LinkedField",
        "name": "Company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessPostMutation",
            "kind": "LinkedField",
            "name": "businessPost",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "companyLayoutId",
                    "variableName": "companyLayoutId"
                  },
                  {
                    "kind": "Variable",
                    "name": "layout",
                    "variableName": "layout"
                  },
                  {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "name"
                  },
                  {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                  }
                ],
                "concreteType": "CompanyLayout",
                "kind": "LinkedField",
                "name": "updateCompanyLayout",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tableId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCompanyLayoutMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateCompanyLayoutMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "cc3aff84df3dbe2e09d12fe3b18b1719",
    "id": null,
    "metadata": {},
    "name": "UpdateCompanyLayoutMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCompanyLayoutMutation(\n  $companyId: ID!\n  $companyLayoutId: Int!\n  $name: String!\n  $layout: String!\n  $status: CompanyLayoutStatusType\n) {\n  Me {\n    Company(id: $companyId) {\n      businessPost {\n        updateCompanyLayout(companyLayoutId: $companyLayoutId, name: $name, layout: $layout, status: $status) {\n          id\n          tableId\n          name\n          status\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f8951d7a875e2b3a085683995605d0bb';

module.exports = node;
